// Lib
import gql from 'graphql-tag';

// Types
import { POST } from '../types';

export const getPostQuery = gql`
  query GetPost($postId: String!) {
    postById(postId: $postId) {
      ${POST}
    }
  }
`;

export const postById = gql`
  query PostById($input: PostByIdInput!) {
    postById(input: $input) {
      ${POST}
    }
  }
`;

export const postByIdUrls = gql`
  query PostByIdUrls($input: PostByIdInput!) {
    postById(input: $input) {
      _id
      attachments {
        media {
          type
          url
        }
        thumbnail {
          url
        }
      }
    }
  }
`;
